module.exports = __webpack_public_path__ + "static/shifts-schedule-and-message-staff-app-49fa8530ea30702066049abeadca259d.png";